import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { reportDWH } from '../../../EsimQrCodeBlockSlice';

const AndroidCodes = (props) => {
    const [isCopyActivationCode, setIsCopyActivationCode] = useState(false);

    useEffect(() => {

    }, []);

    return (
        <>
            <div className='seperator'></div>

            <div className='installation' dangerouslySetInnerHTML={{ __html: props.instructionsTextAndroid }}></div>

            <div className='installation-box'>

                <div className='box-title-wrapper'>
                    <div className='box-title'> קוד הפעלה לקו </div>
                    <div className='box-sub-title'> {props.subscriberNo} </div>
                </div>

                <div className='box-item-wrapper'>
                    <div className='box-item-title'> קוד הפעלה </div>
                    <button className='box-item-value' onClick={() => copyTextToClipboard(props.activationCode, 'activationCode')}>
                        <span>{props.activationCode}</span>
                        <div className={`copy-message-wrapper ${isCopyActivationCode ? 'show' : ''}`}>
                            <div className='copy-message'>הטקסט הועתק</div>
                            <div className='triangle-icon'></div>
                        </div>
                    </button>
                </div>

            </div>
        </>
    );

    function copyTextToClipboard(textToCopy, paramName) {
        if (!textToCopy) { return; }

        props.reportDWH({ actionType: 'Activaion Page - Activation Codes', status: 'Ongoing', messageText: 'Copy Activation Android Codes-  Clicked' });

        try {
            navigator.clipboard.writeText(textToCopy);
        } catch (error) { }

        if (paramName == 'activationCode') {
            setIsCopyActivationCode(true);
            setTimeout(() => { setIsCopyActivationCode(false); }, 3000);
        }
    }

};

const mapStateToProps = (state) => {
    return {
        subscriberNo: state.esimQrCodeBlock.loginDetails.subscriberNo,
        activationCode: state.esimQrCodeBlock.qrCodeDetails.activationCode,
        instructionsTextAndroid: state.esimQrCodeBlock.esimBlockData.instructionsTextAndroid,
    };
};

const mapDispatchToProps = {
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(AndroidCodes);